import React from 'react';
export function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <footer className="bg-[#0a1a0f] border-t border-[#00ff88]/20 py-12" data-id="element-27">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-28">
        <div className="grid md:grid-cols-3 gap-8 mb-8" data-id="element-29">
          <div data-id="element-30">
            <div className="flex items-center space-x-2 mb-4" data-id="element-31">
              <div className="w-8 h-8 bg-gradient-to-br from-[#00ff88] to-[#22c55e] transform rotate-45 flex items-center justify-center" data-id="element-32">
                <div className="w-4 h-4 bg-[#0a1a0f] transform -rotate-45" data-id="element-33"></div>
              </div>
              <span className="text-xl font-bold tracking-wider" data-id="element-34">
                STEELSERIESHUB
              </span>
            </div>
            <p className="text-gray-400 text-sm" data-id="element-35">
              Data-driven sports betting affiliate marketing and SEO agency
              specializing in iGaming growth.
            </p>
          </div>

          <div data-id="element-36">
            <h3 className="text-[#00ff88] font-bold mb-4" data-id="element-37">Quick Links</h3>
            <ul className="space-y-2" data-id="element-38">
              <li data-id="element-39">
                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-[#00ff88] transition-colors text-sm" data-id="element-40">
                  Services
                </button>
              </li>
              <li data-id="element-41">
                <button onClick={() => scrollToSection('results')} className="text-gray-400 hover:text-[#00ff88] transition-colors text-sm" data-id="element-42">
                  Results
                </button>
              </li>
              <li data-id="element-43">
                <button onClick={() => scrollToSection('team')} className="text-gray-400 hover:text-[#00ff88] transition-colors text-sm" data-id="element-44">
                  Team
                </button>
              </li>
              <li data-id="element-45">
                <button onClick={() => scrollToSection('pricing')} className="text-gray-400 hover:text-[#00ff88] transition-colors text-sm" data-id="element-46">
                  Pricing
                </button>
              </li>
            </ul>
          </div>

          <div data-id="element-47">
            <h3 className="text-[#00ff88] font-bold mb-4" data-id="element-48">Contact</h3>
            <ul className="space-y-2 text-sm text-gray-400" data-id="element-49">
              <li data-id="element-50">Limassol, Cyprus</li>
              <li data-id="element-51">
                <a href="mailto:contact@steelserieshub.com" className="hover:text-[#00ff88] transition-colors" data-id="element-52">
                  contact@steelserieshub.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#00ff88]/20 pt-8 text-center" data-id="element-53">
          <p className="text-gray-400 text-sm" data-id="element-54">
            © 2026 Steelserieshub. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}